import React, { Component } from 'react'

import { Toolbar, AppBar, IconButton, Typography } from '@material-ui/core';

import MenuIcon from '@material-ui/icons/Menu';
export default class AppBarView extends Component {
    render() {
        
        const { classes, onClickMenu, titulo,actions } = this.props
        return (
            <AppBar position="fixed" className={classes.appBar}>
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="Open drawer"
                        onClick={onClickMenu}
                        className={classes.menuButton}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" color="inherit" noWrap style={{flexGrow: 1,}}>
                        {titulo}
                    </Typography>
                    {actions?actions():""}
                </Toolbar>
            </AppBar>
        )
    }
}




// WEBPACK FOOTER //
// ./src/App/components/AppBar/AppBar.js